import { AD_CREDIT } from "./AdCredit";
export const PAYMENT = {
  CONNECT_XERO: "/xero-payment/connect",
  VERIFY_XERO_CALLBACK: "/xero-payment/callback",
  CREATE: "/xero-payment",
  UPDATE: (id: string) => `/xero-payment/${id}`,
  DELETE: (id: string) => `/xero-payment/${id}`,
  DETAIL: (id: string) => `/xero-payment/${id}`,
  FIND_OR_CREATE: "/xero-payment",
  GET_CURRENT: "/xero-payment/current",
  REJECT: "/xero-payment/reject",
  ASSET: "/xero-payment/asset",
  MAIN: "/xero-payment",
  APPROVE: "/xero-payment/approve",
  PAYMENT_HISTORY_DETAIL: "/xero-payment-history",
};

export enum EXeroPaymentMethod {
  PAY_NOW = "PAY_NOW",
  CREDIT_CARD = "CREDIT_CARD",
}

export enum PaymentFlow {
  PACKAGE_LDP = "package_ldp",
  AD_CREDIT = "ad_credit",
}
